// extracted by mini-css-extract-plugin
export default {"secondaryTag":"J0224BceIQTHsncLnjai"};